import { z } from 'zod';

import { PayoffId } from '../BrandedIds';
import { ShortageActionType, TrackedPayoffAllowedPaymentMethods } from '../loan/Payoffs';
import { zodBrandedUuid, zodDateOrString } from '../utils/Zod';
import { NonNegativeFloat } from '../validations/fields';
import { BaseLoanEvent } from './BaseLoanEvent';

export const RecordPayoffEvent = BaseLoanEvent.extend({
  type: z.literal('recordPayoff'),
  shortageAction: ShortageActionType.optional(),
  dateReceived: zodDateOrString, // This is the date selected by lender while recording the payoff
  paymentMethod: TrackedPayoffAllowedPaymentMethods,
  referenceId: z.string().optional(),
  submittedBy: z.string().optional(),
  amountReceived: NonNegativeFloat,
  amountExpected: NonNegativeFloat,
  sendEmail: z.boolean(),
  payoffId: zodBrandedUuid<PayoffId>(),
  isPartial: z.boolean().optional(),
  additionalPrincipal: NonNegativeFloat.optional(),
  additionalEscrow: NonNegativeFloat.optional(),
  additionalSuspense: NonNegativeFloat.optional(),
  now: zodDateOrString.optional(),
});

export type RecordPayoffEvent = z.infer<typeof RecordPayoffEvent>;
